import { Component, OnInit, QueryList, ViewChildren  } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { User, SubstPolicy, PickUpCenter } from '../../../_models';
import { UserService,  UtilsService, AuthenticationService, HeaderService } from 'src/app/_services';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ComponentCanDeactivate } from 'src/app/_guards/can-deactivate/component-can-deactivate';
import { UserAddressComponent } from './user-address/user-address.component';
import { DocumentIDValidator } from 'src/app/_validators/document.validator';
import { DatesValidator } from 'src/app/_validators/dates.validator';
import { validateStyleProperty } from '@angular/animations/browser/src/render/shared';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})


export class UserEditComponent extends ComponentCanDeactivate implements OnInit   {

  
  public userDataEditForm: FormGroup; 
  public userSubstPlicyEditForm: FormGroup; 
  public userLanguageForm: FormGroup; 
  
  public user : User;

  public substPolicies : SubstPolicy[];
  public pickUpCenters : PickUpCenter[];

  public f2Submit : boolean;
  public f3Submit : boolean;
  public f4Submit : boolean;

  @ViewChildren(UserAddressComponent) addresses: QueryList<UserAddressComponent>

  constructor(
    private formBuilder: FormBuilder,
    private users : UserService,
    public utils: UtilsService,
    public translate: TranslateService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private auth: AuthenticationService,
    private headerService : HeaderService

  ) {
    super();

    this.users.editingUser.subscribe(user => {
      this.user = user;
    });

    this.utils.getSubstPolicies(this.translate.currentLang).subscribe(subsPolicies => this.substPolicies = subsPolicies );
   }

  get f2() { 
    return this.userDataEditForm.controls; 
  }

  get f3() { 
    return this.userSubstPlicyEditForm.controls; 
  }
  
  get f4() { 
    return this.userLanguageForm.controls; 
  }

  ngOnInit() {

    // this.auth.refresh().subscribe();

    this.userDataEditForm = this.formBuilder.group({
      name: [this.user.name,  Validators.required], 
      surname1: [this.user.surname1,  Validators.required], 
      dni: [this.user.dni,  [Validators.required, DocumentIDValidator.validateDocumentId]],
      birthDateDay: [this.user.birthDay],
      birthDateMonth: [this.user.birthMonth],
      birthDateYear: [this.user.birthYear],
      phone1: [this.user.phone1,  [Validators.required, Validators.minLength(8), Validators.maxLength(16), Validators.pattern(/\+?[0-9]*/) ]] ,
      phone2: [this.user.phone2, [Validators.minLength(8), Validators.maxLength(16), Validators.pattern(/\+?[0-9]*/) ]],
      nobags: [this.user.nobags, [Validators.required]]
    },{validator: DatesValidator.validDayInMonth});

    this.userSubstPlicyEditForm = this.formBuilder.group({
      substPolicy: [this.user.subst_policy,  Validators.required], 
    });

    this.userLanguageForm = this.formBuilder.group({
      language: [this.user.language], 
      publi: [this.user.publi],
      //20250602 axa inici
      factura_electronica: [this.user.factura_electronica],
      //20250602 axa final
    });

    this.f2Submit = false;
    this.f3Submit = false;
    this.f4Submit = false;

  }

  canDeactivate() : boolean {
    return !this.userDataEditForm.dirty ;
  }

  onSubmitUserDataEditForm(){
    if (this.userDataEditForm.invalid){
      this.f2Submit = true;
      return;
    }
    
    
    let user = new User(this.user);
    user.name = this.f2.name.value;
    user.surname1 = this.f2.surname1.value;
    user.dni = this.f2.dni.value;
    user.birth_date = this.datePipe.transform( new Date(this.f2.birthDateYear.value,this.f2.birthDateMonth.value -1 , this.f2.birthDateDay.value), 'dd/MM/yyyy');
    user.phone1 = this.f2.phone1.value;
    user.phone2 = this.f2.phone2.value;
    user.nobags = this.f2.nobags.value;

    this.updateUser(user);
    this.f2Submit = false;
    this.userDataEditForm.markAsPristine();
  }

  onSubmitUserSubstPlicyEditForm(){
    if (this.userSubstPlicyEditForm.invalid){
      this.f3Submit = true;
      return;
    }
    
    let user = new User(this.user);
    user.subst_policy = this.f3.substPolicy.value;

    this.updateUser(user);
    this.f3Submit = false;
    this.userSubstPlicyEditForm.markAsPristine();
  }

  onSubmitUserLanguageForm(){
    if (this.userLanguageForm.invalid){
      this.f4Submit = true;
      return;
    }
    
    let user = new User(this.user);
    user.language = this.f4.language.value;
    user.publi = this.f4.publi.value ? 1 : 0;
    //20250602 axa inici
    user.factura_electronica = this.f4.factura_electronica.value ? 0 : 1;
    //20250602 axa final

    this.updateUser(user);   
    this.translate.use(user.language);
    this.f4Submit = false;
    this.userLanguageForm.markAsPristine();
  }

  updateUser(user : User){
    this.users.update(user).subscribe( result => {
    });
  }
}
